import { FC } from 'react';
import { Badge } from './Badge';
import { LockIcon } from '../theme/Icons';

export const PrivacyBadge: FC<{'data-type'?: string; useLock?: boolean}> = ({ 'data-type': dataType, useLock }) => {
    return (
        useLock ? (
            <LockIcon color="secondary" size="small" />
        ) : (
            <Badge data-type={dataType} size="xsmall" color="secondary">Private</Badge>
        )
    );
};
